// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'regenerator-runtime';
import Vue from 'vue';
import smoothScroll from 'vue-smoothscroll';
import VueLazyload from 'vue-lazyload';
import ClickOutsideDirective from '@/plugins/directive-click-outside';
import * as VueGoogleMaps from 'vue2-google-maps';

import VueMeta from 'vue-meta';
import ValidationProvider from './plugins/validation';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App, ValidationProvider },
  template: '<App/>',
});

Vue.use(smoothScroll);
Vue.use(VueLazyload, {
  observer: true,
});
Vue.directive('click-outside', ClickOutsideDirective);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAPA7hrZMHTChN9j7e3sq6VLr6-jcS1C9k',
    libraries: 'places',
    region: 'JP',
    language: 'ja',
  },
});
Vue.config.productionTip = false;
Vue.use(VueMeta);
